export default __webpack_public_path__ + "static/media/undraw_Setup_re_y9w8.de6b406f.svg";